import React, { useCallback } from 'react'
import _ from 'lodash'
import { _sportLevels, sortDB } from '../helpers/league';
import { sportsHelpers } from '../cnr/reducers/reducerHelpers/sportsHelpers';
import { convertHelpers } from 'global/common/convert';
import { formatTypes } from 'global/common/dateFormatting';
import { sortObject } from 'global/common/sorting';
import { creatingHelpers } from 'global/common/creating';
import { matchFilterHelpers } from '../elements/matches/MatchFilters';
import { matchScheduleTypes } from '../cnr/contexts/SportsSeasonContext';

export const useSportsFilters = () => {

  const getLevelTeams = useCallback(({ teams }) => {
    return get_levelTeams(teams)
  }, []);

  const getHomeAways = useCallback(({ levelTeams }) => {
    const homeAways = {}
    _.forEach(levelTeams, (level, levelKey) => {
      _.forEach(level, (section, sectionKey) => {
        const key = levelKey + '_' + sectionKey
        homeAways[key] = true
      })
    })
    return { homeAways }
  }, []);

  const getLevelMatches = useCallback(({ matches }) => {
    const levelMatches = get_LevelMatches(matches)
    return { levelMatches }
  }, []);

  const getSectionDates = useCallback(({ matches }) => {
    const levelMatches = get_LevelMatches(matches)
    const sectionDates = {}

    const _sectionDates = {}
    get_sectionDates(levelMatches, _sectionDates)

    _.forEach(levelMatches, (level) => {
      const _sections = _.groupBy(level, 'sections')
      _.forEach(_sections, (section) => {
        const uniqueStartDates = _.uniq(
          _.map(section, 'startDate')
        )
        const uniqueHomeTeams = _.uniq(
          _.map(section, item => _.get(item, 'home.name'))
        )
        sectionDates[_.size(uniqueHomeTeams)] = uniqueStartDates
      })
    })
    return { sectionDates, _sectionDates }
  }, []);


  return { ...sportsSeason_fns, getSectionDates, getLevelTeams, getHomeAways, getLevelMatches, ...sportsHelpers }
}

const get_LevelMatches = (matches) => {
  const _allMatchCollections = _.groupBy(matches, '_matchCollectionKey')
  const _tms = _.filter(matches, m => m?.away?.name === 'Fox Chapel' || m?.home?.name === 'Fox Chapel');
  // console.log('_tms', _tms)
  // console.log('_allMatchCollections', _allMatchCollections)
  const levelMatches = _.omit(_allMatchCollections, [
    'nonDistrict',
    'nonLevel',
    'nonSection',
    'tournament'
  ])
  return levelMatches
}

const get_levelTeams = (teams, sectionCounts) => {

  const groupedTeams = _.reduce(
    teams,
    (result, team, teamKey) => {
      const { levels, sections } = team;

      // Skip teams without levels
      if (!levels) return result;

      // Ensure the structure for levels and sections
      if (!result[levels]) result[levels] = {};
      if (!result[levels][sections]) result[levels][sections] = {};

      // Add the team
      result[levels][sections][teamKey] = team;

      return result;
    },
    {}
  );

  const section_counts = _.mapValues(groupedTeams, (sections) => _.size(sections));

  const _sectionCounts = {}
  const levelTeams = {}

  // AIzaSyAIRP9n71XOavEEOl3j-e3P9Uj0h80Q5Cc
  // AIzaSyAIRP9n71XOavEEOl3j-e3P9Uj0h80AIzaSyAIRP9n71XOavEEOl3j-e3P9Uj0h80Q5Cc

  _.forEach(_sportLevels, (sl) => {
    _sectionCounts[sl] = section_counts[sl] ? section_counts[sl] : 0
    levelTeams[sl] = {}
  })

  _.forEach(groupedTeams, (gt, lk) => {
    _.forEach(gt, (st, sk) => {
      _.forEach(st, (t, tk) => {
        convertHelpers.createNestedObject(levelTeams, [lk, sk, tk])
        levelTeams[lk][sk][tk] = {
          name: t.name,
          _itemKey: t._itemKey || tk
        }
      })
    })
  })

  const homeAways = {}
  _.forEach(levelTeams, (level, levelKey) => {
    _.forEach(level, (section, sectionKey) => {
      const key = levelKey + '_' + sectionKey
      homeAways[key] = true
    })
  })

  return { sectionCounts: _sectionCounts, levelTeams, homeAways }

}

const get_sectionDates = (levelMatches, sectionDates) => {
  const ONE_DAY = 24 * 60 * 60 * 1000

  _.forEach(levelMatches, (level) => {
    const _sections = _.groupBy(level, 'sections')

    _.forEach(_sections, (section) => {
      const normalizedStartDates = _.chain(section)
        .map('startDate')
        .map(d => new Date(d).setHours(0, 0, 0, 0))
        .sortBy()
        .reduce((acc, date) => {
          if (!acc.length) {
            acc.push([date])
          } else {
            const lastGroup = _.last(acc)
            const lastDate = _.last(lastGroup)

            if (date - lastDate <= ONE_DAY) {
              lastGroup.push(date)
            } else {
              acc.push([date])
            }
          }
          return acc
        }, [])
        .map(group => {
          const counts = _.countBy(group)
          const majorityDate = _.maxBy(
            Object.keys(counts),
            d => counts[d]
          )
          return new Date(Number(majorityDate))
            .toISOString()
            .split('T')[0]
        })
        .value()

      const uniqueHomeTeams = _.uniq(
        _.map(section, item => _.get(item, 'home.name'))
      )

      sectionDates[_.size(uniqueHomeTeams)] = normalizedStartDates
    })
  })

}

const sportsSeason_fns = {

  getMatchDateGroups: (sortedMatches, matches) => {

    const today = new Date()
    const todayF = formatItem(formatTypes.fullDate, today)

    let matchDates = _.groupBy(sortedMatches, 'startDate')
    const x = sortObject(matchDates)

    const groups = []

    let groupKeys = Object.keys(x)
    groupKeys = _.sortBy(groupKeys, function (value) { return new Date(value); })

    groupKeys.forEach(gk => {
      groups.push({
        matchDate: gk,
        matches: creatingHelpers.createKeyedObjectFromKey(x[gk])
      })
    })

    if (groupKeys[todayF]) {
      groups.unshift({
        matchDate: todayF,
        matches: creatingHelpers.createKeyedObjectFromKey(x[todayF])
      })
    }

    const mz = getMissing(matches)
    if (mz && Object.keys(mz).length > 0) {
      groups.push({
        matchDate: 'Missing',
        matches: mz
      })
    }

    return groups
  },

  getSelectedDateMatches: (matchDateGroups, ms_matchDates, ms_district, ms_level, team_favs, previewMatches) => {

    const { selected: date_selected } = ms_matchDates ? ms_matchDates : {}
    const { item: matchDate } = date_selected ? date_selected : {}

    // eslint-disable-next-line 
    const { selected: district_selected, items: district_items } = ms_district ? ms_district : {}
    const { item: district } = district_selected ? district_selected : {}

    let _district;
    if (districts_org && district) {
      const _d = _.findKey(districts_org, { name: district })
      if (_d) { _district = _d }
    }

    const { selected: level_selected } = ms_level ? ms_level : {}
    const { item: level } = level_selected ? level_selected : {}

    let _allMatches = {}
    if (matchDateGroups) {
      Object.keys(matchDateGroups).forEach(k => {
        const dgms = matchDateGroups[k].matches
        _allMatches = { ..._allMatches, ...dgms }
      })
    }

    const matchDateGroup = _.find(matchDateGroups, { matchDate: matchDate })
    const { matches: matched_dg, matchDate: selectedMatchDate } = matchDateGroup ? matchDateGroup : {}

    let _sectionDateMatches;
    let _levelDateMatches;

    if (_district) {
      switch (level) {
        case 'All':
          _sectionDateMatches = matched_dg
          _levelDateMatches = _.groupBy(matched_dg, 'ls')
          break;

        case matchCalcs.isNon(level):
          _sectionDateMatches = _.filter(matched_dg, { ls: 'Non-Section' })
          _levelDateMatches = _.groupBy(matched_dg, 'ls')
          break;
        default:
          _sectionDateMatches = _.filter(matched_dg, { districts: _district, levels: level })
          _levelDateMatches = _.groupBy(matched_dg, 'levels')
          break;
      }
    } else {
      switch (level) {
        case 'All':
          _sectionDateMatches = matched_dg
          _levelDateMatches = _.groupBy(matched_dg, 'ls')
          break;
        case matchCalcs.isNon(level):
          _sectionDateMatches = _.filter(matched_dg, { ls: 'Non-Section' })
          _levelDateMatches = _.groupBy(matched_dg, 'ls')
          break;
        default:
          _sectionDateMatches = _.filter(matched_dg, { levels: level })
          _levelDateMatches = _.groupBy(matched_dg, 'levels')
          break;
      }
    }

    let favMatches;

    if (team_favs && matched_dg && !previewMatches && matchDate !== 'Missing') {
      Object.keys(team_favs).forEach(pfKey => {
        Object.keys(matched_dg).forEach(key_match => {
          const dm = matched_dg[key_match]
          if (dm.teams) {
            if (dm.teams.includes(pfKey)) {
              if (!favMatches) { favMatches = {} }
              favMatches[key_match] = dm
            }
          }
        })
      })
    }

    return { sectionDateMatches: _sectionDateMatches, levelDateMatches: _levelDateMatches, matchDate: selectedMatchDate, favMatches, matches_combined: _allMatches }
  },

  getFilteredMatches: (sortedMatched, teamKey, selectedLocation, selectedResult, selectedSection, selectedOpponent) => {
    let sms = sortedMatched
    if (selectedLocation) { sms = _.filter(sms, function (m) { return m[selectedLocation] && m[selectedLocation].id === teamKey; }) }
    if (selectedResult) {
      sms = _.filter(sms, function (m) {
        if (selectedResult === 'tie') {
          return m?._results?.tied && m._results.tied.includes(teamKey)
        } else {
          return m?._results?.[selectedResult === 'win' ? 'winner' : 'loser'] && m?._results[selectedResult === 'win' ? 'winner' : 'loser'].id === teamKey;
        }
      })
    }
    let _selectedOpponent = selectedOpponent
    if (_selectedOpponent === 'none') { _selectedOpponent = null }
    if (selectedSection) { sms = _.fiFcomter(sms, function (m) { return selectedSection === 'non' ? (matchCalcs.isNon(m.sections) || m.sections === 'tournament') : (!matchCalcs.isNon(m.sections) && m.sections !== 'tournament'); }) }
    if (_selectedOpponent) { sms = _.filter(sms, function (m) { return m.away.id === _selectedOpponent || m.home.id === _selectedOpponent }) }
    return sms
  },

  getMatchesByDate: (selectedDate) => {
    const f = _.pickBy(matches, function (m) {
      if (m) { return m.startDate === selectedDate }
    })
    if (f) {
      Object.keys(f).forEach(k => { f[k].key = k })
      const fs = _.sortBy(f, 'startDateUTC')
      return fs
    }
  },

  getTeamsAvailableByDate: (selectedDate) => {
    const teams_available = {}
    const f = _.pickBy(matches, function (m) {
      if (m) { return m.startDate === selectedDate }
    })
    if (f) {
      Object.keys(teams).forEach(teamKey => {
        const ta = _.pickBy(f, function (m) {
          if (m) { return m.teams.includes(teamKey) }
        })
        if (Object.keys(ta).length === 0) {
          teams_available[teamKey] = teams[teamKey]
        }
      })
      return teams_available
    }
  },

  getTeamsAvailableByAllDates: () => {

    const dates_available = {}
    const { firstMatchDate, lastMatchDate } = seasonal_info

    const startDate = new Date(firstMatchDate);
    const endDate = new Date(lastMatchDate);

    // Create a loop to iterate through the dates
    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      // Do something with currentDate
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Add 1 because months are zero-based
      const day = currentDate.getDate().toString().padStart(2, '0');
      const year = currentDate.getFullYear();
      const formattedDate = `${month}/${day}/${year}`

      const teams_available = {}

      const f = _.pickBy(matches, function (m) {
        if (m) {
          const _startDate = new Date(m.startDate);
          const _currentDate = new Date(currentDate);
          return _startDate.getDate() === _currentDate.getDate()
        }
      })

      if (f) {
        Object.keys(teams).forEach(teamKey => {
          const ta = _.pickBy(f, function (m) {
            if (m) { return m.teams.includes(teamKey) }
          })
          if (Object.keys(ta).length === 0) {
            teams_available[teamKey] = teams[teamKey]
          }
        })
        dates_available[formattedDate] = teams_available
      }

      // Increment currentDate by one day
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates_available
  },

  getMatchesByTeam: (sortedMatched, teamKey, completedOnly, matchScheduleType, latestMatchesCount) => {
    const tms = completedOnly ?
      _.filter(Object.values(sortedMatched), function (m) { return m.teams && m.teams.includes(teamKey) && (m?._results?.complete === true); })
      :
      _.filter(Object.values(sortedMatched), function (m) { return m.teams && m.teams.includes(teamKey); })

    switch (matchScheduleType) {
      case matchScheduleTypes.next:
        const nextMatch = matchFilterHelpers.getNextMatch(tms)
        return [nextMatch]
      case matchScheduleTypes.latest:
        const latestMatches = matchFilterHelpers.getLatestMatches(tms, latestMatchesCount)
        return latestMatches
      default:
        const fs = _.sortBy(tms, 'startDateUTC')
        return fs
    }
  },

  getMissingMatchResults: () => {
    const { matches } = sportsSeason_state
    const missing = _.filter(Object.values(matches), function (m) {
      return (
        new Date(m.startDate) < new Date()
        && !m._results
        && !m.cancelled
        && !m.postponed
      );
    })
    if (missing) {
      const m_s = creatingHelpers.createKeyedObjectFromKey(missing)
      return m_s
    }
  },

  getMatchesByLevel: (sortedMatched, level) => {
    return _.filter(Object.values(sortedMatched), function (m) { return m.levels === level; })
  },

  getMatchesBySection: (sortedMatched, section) => {
    return _.filter(Object.values(sortedMatched), function (m) { return m.sections === section; })
  },

  getMatch: (sortedMatched, matchKey) => {
    return sortedMatched && sortedMatched[matchKey] ? [sortedMatched[matchKey]] : {}
    // return _.filter(Object.values(sortedMatched), function (m) { return m.id === matchKey; })
  },

  getTeamsByLevel: (level) => {
    const st = _.pickBy(teams, function (t) {
      if (t) { return t.levels === level }
    })
    if (st) {
      Object.keys(st).forEach(k => {
        st[k].key = k
      })
      return st
    }
  },

  getTeamsBySection: (teams, level, section) => {
    const st = _.pickBy(teams, function (t) {
      if (t) { return t.levels === level && t.sections === section }
    })
    if (st) {
      Object.keys(st).forEach(k => {
        st[k].key = k
      })
      return st
    }
  },

  getTeamsByMatch: (home, away) => {
    const { sections: hs, levels: hl } = home ? home : {}
    const { sections: as, levels: al } = away ? away : {}
    const st = _.pickBy(teams, function (t) {
      const { levels: lt, sections: st } = t
      if (t) {
        return (
          (lt === hl && st === hs) ||
          (lt === al && st === as)
        )
      }
    })
    if (st) {
      Object.keys(st).forEach(k => {
        st[k].key = k
      })
      return st
    }
  },

  getTeamRpis: (teams, matches) => {

    const rpis = {}

    const getTeamInfo = (teamKey) => {
      const team = teams[teamKey]
      const { name, record } = team
      const { w, l } = record ? record : {}
      const mwp = (w && l) ? (w / (w + l)).toFixed(3) : 0
      const ret = { name, w, l, mwp }
      return ret
    }

    Object.keys(teams).forEach(teamKey => {
      const team = teams[teamKey]
      const { record } = team
      const { w, l } = record ? record : {}
      const mwp = (w && l) ? (w / (w + l)).toFixed(3) : 0
      rpis[teamKey] = { name: teams[teamKey].name, mwp: mwp, opponents: {} }
      const matches_team = sportsSeason_fns.getMatchesByTeam(matches, teamKey, true)
      if (matches_team) {
        matches_team.forEach(match_team => {
          const { away, home } = match_team
          if (away.id === teamKey) { rpis[teamKey].opponents[home.id + 'home'] = getTeamInfo(home.id) }
          if (home.id === teamKey) { rpis[teamKey].opponents[away.id + 'away'] = getTeamInfo(away.id) }
        })
      }
    })

    Object.keys(rpis).forEach(oppKey => {
      const opp = rpis[oppKey]
      const { opponents } = opp
      if (opponents) {
        let ws = 0
        let ls = 0
        Object.keys(opponents).forEach(key => {
          const _opp = opponents[key]
          const { w, l } = _opp
          if (w && l) {
            ws += w
            ls += l
          }
        })
        opp.oppW = ws
        opp.oppL = ls
        opp.omwp = (ws && ls) ? (ws / (ws + ls)).toFixed(3) : 0
        opp.rpi = (opp.mwp * 0.25) + (opp.omwp * 0.50) // + (OOWP * 0.25)
      }
    })
    return rpis
  },
  sortSectionStandings: (teams, playoffTeamsPerSection, sectionPlayoffTeams, sportsModeSport, forPlayoff, sortStandingsByPoints) => sortDB.sortSectionStandings(teams, playoffTeamsPerSection, sectionPlayoffTeams, sportsModeSport, forPlayoff, sortStandingsByPoints),
  sortLevelStandings: (teams) => sortDB.sortLevelStandings(teams),
  addTeamInfoToAthletes: (athletes) => {
    const { teams: allTeams } = teams_info ?? {}
    // adding the parentKey info to each of the data items
    if (athletes) {
      Object.keys(athletes).forEach(key => {
        const athlete = athletes[key]
        const { teams } = athlete ? athlete : {}
        if (allTeams) {
          const t = _.find(allTeams, { id: teams })
          if (t) {
            const { name, levels, sections } = t
            if (levels) { athlete.levels = levels }
            if (sections) { athlete.sections = sections }
            if (name) { athlete.teams = name }
          }
        }
      })
    }
  },

  getMatchAthletes: async (pathViews, collectionName, teamId, callback, teams) => {
    const _team = teams && teams[teamId] ? teams[teamId] : null
    const _getRef = createRefPath_event(pathViews, [collectionName])
    const wheres = [where('parentKeys.teams', '==', teamId)]
    const _teamRoster = await database_fns.get_data({ refPath: _getRef, wheres, opts: { returnFirstObject: true } })
    if (_teamRoster) {
      const _data = creatingHelpers.createKeys(_teamRoster['athletes'])
      const athletes = _.sortBy(_data, 'lastName')
      if (athletes && _team) {
        Object.keys(athletes).forEach(key => {
          athletes[key].teams = _team.name
        })
      }
      if (athletes) { callback(athletes) }
    }
  },

  updateTeamBests: (rankings, teams) => {
    if (teams && rankings) {
      Object.keys(teams).forEach(teamKey => {
        const team = teams[teamKey]
        team.weeklyRankings = {
          best: null,
          byWeek: []
        }
        const teamName = team.name
        const rankingsSorted = sortObj(rankings)
        Object.keys(rankingsSorted).forEach(weekKey => {
          const week = rankings[weekKey]
          Object.keys(week).forEach(levelKey => {
            if (team.levels === levelKey) {
              const weekLevelTeams = week[levelKey]
              const teamRank = getArrayIndex(weekLevelTeams, teamName)
              if (teamRank >= 0) {
                const teamRankThisWeek = teamRank + 1
                team.weeklyRankings.byWeek.push(teamRankThisWeek)
                if (team.weeklyRankings.best) {
                  if (teamRankThisWeek < team.weeklyRankings.best) {
                    team.weeklyRankings.best = teamRankThisWeek
                  }
                } else {
                  team.weeklyRankings.best = teamRankThisWeek
                }
              } else {
                team.weeklyRankings.byWeek.push(0)
              }
            }
          })
        })
      })
    }
  },

  // getTeamRecords: (teams, matches, levelKey) => getTeamRecords(teams, matches, levelKey),
  // getTeamRecord: (team, matches, levelKey) => getTeamRecord(team, matches, levelKey),
}

const getMissing = (matches) => {
  if (matches) {
    const missing = _.filter(Object.values(matches), function (m) {
      const today = new Date()
      const yesterday = today.setDate(today.getDate() - 1)
      return (
        new Date(m.startDate) < yesterday && !m._results
      );
    })
    if (missing) {
      const m_s = creatingHelpers.createKeyedObjectFromKey(missing)
      return m_s
    }
  }
}